/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取app引导图
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  pictureType: string,
  versionNum: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.GuideResponseOutObjects;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/setting/app/version/guide/${versionNum}/${pictureType}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
